import { useQuery } from 'react-query';
import { network } from 'services/network';
import { QueryKeys } from 'api/queryKeys';
import qs from 'qs';

const queryFn = (params: QueryParams) => {
    const querystring = qs.stringify(params, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/getSubProgramPreferenceProgressScurve${querystring}`;
    return network.get(url).then((response) => response.data);
};

export const useQueryGetSubProgramPreferenceProgressScurve = (params: QueryParams) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['getSubProgramPreferenceProgressScurve', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.subProgramId),
    });
};

interface QueryParams {
    subProgramId?: number;
}

export type QueryResponse = 'CRITICALITY_WEIGHT_S_CURVE' | 'ACTIVITIES_COMPLETE_S_CURVE' | 'RESOURCE_UNITS_S_CURVE';
